import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import planReducer from './planReducer'

export default combineReducers({
    routing: routerReducer,
    planReducer
})


// WEBPACK FOOTER //
// ./src/modules/reducer.js